import React from 'react';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Navbar from 'react-bootstrap/Navbar';
import InputGroup from 'react-bootstrap/InputGroup';
import 'bootstrap/dist/css/bootstrap.min.css'; // Ensure Bootstrap CSS is imported

function AppNavBarSearch() {
  return (
    <Navbar expand="lg" className="bg-body-tertiary">
      <Container fluid className="justify-content-center"> {/* Center the form */}
        <Form className="d-flex" style={{ width: '50%' }}> {/* Set width to control size */}
          <InputGroup>
            <Form.Control
              type="search"
              placeholder="Search"
              aria-label="Search"
            />
            <Button variant="outline-success">
              Search
            </Button>
          </InputGroup>
        </Form>
      </Container>
    </Navbar>
  );
}

export default AppNavBarSearch;
